import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UniversitySettingService} from '../../shared/services/university-setting.service';

@Component({
    selector: 'app-settings',
    templateUrl: './universitysettings.component.html',
    styleUrls: ['./universitysettings.component.scss']
})
export class UniversitysettingsComponent implements OnInit {
    showSearch = false;
    id: any;
    data: any;
    updatePasswordForm: FormGroup;
    inputTypePassword = 'password';
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    settings = [];

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private universitySettingService: UniversitySettingService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'current_session_year': [''],
            'student_application_id_prefix': ['']
        });
        this.get();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-setting').toggleOpen();
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.get({page: 1, total: null, perpage: 15, pages: null});
        }
        this.toggleSidebar();
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.settings = [];
        this.universitySettingService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.settings = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.settings = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    search() {
        const params = {
            'current_session_year': (this.searchForm.value && this.searchForm.value.current_session_year) ? this.searchForm.value.current_session_year : '',
            'student_application_id_prefix': (this.searchForm.value && this.searchForm.value.student_application_id_prefix) ? this.searchForm.value.student_application_id_prefix : '',
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            'current_session_year': (this.searchForm && this.searchForm.value && this.searchForm.value.current_session_year) ? this.searchForm.value.current_session_year : '',
            'student_application_id_prefix': (this.searchForm && this.searchForm.value && this.searchForm.value.student_application_id_prefix) ? this.searchForm.value.student_application_id_prefix : '',
        };
        this.get(params);
    }

    edit(data) {
        this.data = data;
        this.toggleSidebar();
    }

    updateStatus(status, data) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                'status': status
            };
            this.submitting = true;
            this.universitySettingService.updateStatus(data.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.modalService.dismissAll('');
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }
}
